// src/modules/app-views/offers/pages/Document/decorators/request.js
// *******************************************************************************
// REQUEST DECORATOR
// Transforms data before sending to the server
// *******************************************************************************

/**
 * Transforms form data before sending to the server
 *
 * @param {Object} ctx - Context object
 * @param {Object} ctx.data - Form data to be sent (changed fields only)
 * @param {Object} ctx.allValues - Complete form data with original values
 * @param {String} ctx.url - Request URL
 * @param {String} ctx.method - HTTP method
 * @returns {Object} Transformed data ready for backend
 */
const decorateRequest = ctx => {
  const { data } = ctx;

  if (!data) return data;

  // Clone data to avoid mutations
  const transformed = { ...data };

  return transformed;
};

export default decorateRequest;
